<div class="message-progress" *ngIf="hasSteps" [class.message-progress--collapsed]="collapsed">
  <button type="button" class="message-progress__summary" [attr.aria-expanded]="!collapsed" (click)="toggle()">
    <svg-icon src="assets/icons/arrow-right.svg" class="message-progress__chevron" [class.message-progress__chevron--open]="!collapsed" aria-hidden="true"></svg-icon>
    <span>{{ summary }}</span>
  </button>

  <ol class="message-progress__steps" *ngIf="!collapsed" role="status" aria-live="polite">
    <ng-container *ngFor="let step of steps; trackBy: trackByStep">
      <li class="message-progress__note" *ngIf="step.type === 'thinking'">{{ step.text }}</li>

      <li
        class="message-progress__chip"
        *ngIf="step.type === 'tool'"
        [class.message-progress__chip--running]="step.inProgress"
        [class.message-progress__chip--failed]="!step.inProgress && step.ok === false"
      >
        <svg-icon [src]="iconFor(step)" class="message-progress__kind-icon" aria-hidden="true"></svg-icon>
        <span class="message-progress__label">{{ step.label }}</span>
        <span class="message-progress__state" role="img" [attr.aria-label]="stateLabel(step)">
          <span class="message-progress__spinner" *ngIf="step.inProgress" aria-hidden="true"></span>
          <svg-icon *ngIf="!step.inProgress && step.ok !== false" src="assets/icons/check.svg" class="message-progress__state-icon" aria-hidden="true"></svg-icon>
          <svg-icon *ngIf="!step.inProgress && step.ok === false" src="assets/icons/warning-icon.svg" class="message-progress__state-icon" aria-hidden="true"></svg-icon>
        </span>
      </li>
    </ng-container>
  </ol>
</div>
